import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

interface GetIndustryTemplateArgs {
	enabled?: boolean;
	industry?: string;
	types?: Api.TemplateType[];
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
}

const BASE_QUERY_KEY = 'template/system';

export const useGetTemplatesByIndustry = ({
	enabled,
	industry,
	types,
	impersonationContext,
	meta,
}: GetIndustryTemplateArgs) => {
	const userSession = useUserSession();
	const queryParams: Record<string, any> = {
		industry: industry || userSession.account?.toJs().additionalInfo?.industry || Api.Industry.Miscellaneous,
	};

	return useQuery({
		queryFn: async () => {
			if (types?.length > 0) {
				queryParams.types = types;
			}

			return userSession.webServiceHelper.callAsync<Api.ITemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template/system`,
					impersonationContext,
					queryParams,
				}),
				'GET',
				null
			);
		},
		enabled,
		queryKey: [BASE_QUERY_KEY, queryParams.industry, types, impersonationContext],
		meta,
	});
};

export const invalidateAllTemplateSystemQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
